<div *ngIf="vidBlock" class="modal-content">
  <div class="modal-header">
    Edit Video
    <i class="material-icons" data-bs-dismiss="modal" (click)='closeEditVideoModal()'>close</i>
  </div>
  <div class="modal-body me-3">
    <div class="form-group row align-items-center mt-1">
      <label class="col-sm-2 control-label">Source</label>
      <div class="col-sm-10">
        <div class="btn-group" btnRadioGroup id="SourceTypeId">
          <label btnRadio="false" (click)="vidBlock.external = false;"
            [ngClass]="{'btn__active': vidBlock.external == false}" class="btn btn__outline" role="button">File</label>
          <label btnRadio="true" (click)="vidBlock.external = true;"
            [ngClass]="{'btn__active': vidBlock.external == true}" class="btn btn__outline" role="button">URL</label>
        </div>
      </div>
    </div>

    <div class="form-group row align-items-center mt-1">
      <label class="col-sm-2 control-label">Video Title</label>
      <div class="col-sm-10">
        <input class="form-control" type="text" [(ngModel)]="vidBlock.videoTitle" />
      </div>
    </div>

    <div class="form-group row align-items-center mt-1">
      <label class="col-sm-2 control-label">Talent Name</label>
      <div class="col-sm-10">
        <input class="form-control" type="text" [(ngModel)]="vidBlock.talentName" />
      </div>
    </div>

    <div class="form-group row align-items-center mt-1">
      <label class="col-sm-2 control-label">Description</label>
      <div class="col-sm-10">
        <textarea class="form-control" type="text" [(ngModel)]="vidBlock.description"></textarea>
      </div>
    </div>

    <div class="form-group" *ngIf="!vidBlock.external">
      <div class="row" [ngStyle]="vidBlock.assetId && {'margin-top':'30px'}">
        <label class="col-sm-2 control-label">Video</label>
        <div class="col-sm-5" [ngStyle]="{'margin-top': vidBlock.assetId ? '-30px' : '0px'}">
          <i [hidden]="!vidBlock.assetId" class="material-icons pull-right mt-10 pointer"
            (click)="removeAsset(1)">delete</i>
          <div class="upload-assets">
            <div (click)="openFileDialog(1)" class="upload-assets-file">
              <div class="upload-box">
                <span class="material-icons upload-icon upload-icon-color" *ngIf="!vidBlock.assetId">cloud_upload</span>
                <app-vplaybook-video-viewer *ngIf="vidBlock.assetId" style="width: 100%; height:100%;"
                  [setIsPlaying]="false" [videoAssetId]="vidBlock.assetId" [setVideoSrc]="getAssetSrc(1)">
                </app-vplaybook-video-viewer>
              </div>
              <div class="file-upload hide">
                <app-video-chunks-upload (progressPercentage)="progressPercentage($event)"
                  [chunksClass]="'file-upload__input'" (fileStatusUpdate)="fileStatusUpdate($event)" [apiUrl]="apiUrl">
                </app-video-chunks-upload>
              </div>
            </div>
            <section class="modal-pop" *ngIf="showProgress.mp4" style="position:relative !important;">
              <div class="progress progress-striped active">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                  [attr.aria-valuenow]="progressPercent.mp4" aria-valuemin="0" aria-valuemax="100"
                  [ngStyle]="!videoProcessing && {'width' : progressPercent.mp4+'%'} || {'width' : '100%'}"
                  [ngClass]="(progressPercent.mp4) ? 'white-font' : 'show-initial-status'">
                  {{ !videoProcessing ? progressPercent.mp4 + '%' : ''}} {{videoProcessing}}
                </div>

              </div>
            </section>
            <span class="video-file-name align-content-end" title="{{vidBlock.asset?.name || 'Upload MP4 Video'}}">
              {{(vidBlock.asset?.name || "Upload MP4 Video") }}
            </span>
          </div>
        </div>
        <div class="col-sm-5" [ngStyle]="{'margin-top': vidBlock.placeHolderImageId ? '-30px' : '0px'}">
          <i [hidden]="!vidBlock.placeHolderImageId" class="material-icons pull-right mt-10 pointer"
            (click)="removeAsset(3)">delete</i>
          <div class="upload-assets">
            <div (click)="openFileDialog(3)" class="upload-assets-file">
              <div *ngIf="!vidBlock.placeHolderImageId; else imgselected" class="upload-box pointer"
                title="click to change file">
                <span class="material-icons upload-icon upload-icon-color">cloud_upload</span>
              </div>
              <ng-template #imgselected>
                <img id="imgBackground" title="click to change file"
                  [ngStyle]="{'width': vidBlock.placeHolderImageId ? 'auto' : '100%'}" class="upload-box pointer"
                  [src]="getAssetSrc(3) | loadSecureAssets  : true | async" alt="" />
              </ng-template>
              <div class="file-upload hide">
                <input id="uploadplaceholder" #fileInput (click)="fileInput.value = null"
                  (change)="fileSelected($event,3)" accept="image/jpg, image/jpeg, image/png" class="file-upload__input"
                  type="file" name="preview-file-upload">

              </div>
            </div>
            <section class="modal-pop" *ngIf="showProgress.image" style="position:relative !important;">
              <div class="progress progress-striped active">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                  [attr.aria-valuenow]="progressPercent.image" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="progressPercent.image+'%'">
                  {{progressPercent.image}}%
                </div>
              </div>
            </section>
            <span class="video-file-name align-content-end"
              title="{{vidBlock.placeHolderImage?.name || 'Upload JPEG or PNG'}}">
              {{(vidBlock.placeHolderImage?.name || "Upload JPEG or PNG") }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-2 align-items-center form-group" *ngIf="vidBlock.external">
      <label class="col-sm-2 control-label" for="url">Video URL</label>
      <div class="col-sm-10">
        <input type="text" [(ngModel)]="vidBlock.url" class="form-control vplaybook__form__inputs">
      </div>
      <ng-container *ngIf="checkVideoUrl(vidBlock.url)">
        <label class="col-sm-2 control-label" for="url">PlaceHolder</label>
        <div class="col-sm-10">
          <i [hidden]="!vidBlock.placeHolderImageId" class="material-icons pull-right mt-10 pointer"
            (click)="removeAsset(3)">delete</i>
          <div class="upload-assets">
            <div (click)="openFileDialog(3)" class="upload-assets-file">
              <div *ngIf="!vidBlock.placeHolderImageId; else imgselected" class="upload-box pointer"
                title="click to change file">
                <span class="material-icons upload-icon upload-icon-color">cloud_upload</span>
              </div>
              <ng-template #imgselected>
                <img id="imgBackground" title="click to change file"
                  [ngStyle]="{'width': vidBlock.placeHolderImageId ? 'auto' : '100%'}" class="upload-box pointer"
                  [src]="getAssetSrc(3) | loadSecureAssets  : true | async" alt="" />
              </ng-template>
              <div class="file-upload hide">
                <input id="uploadplaceholder" #fileInput (click)="fileInput.value = null"
                  (change)="fileSelected($event,3)" accept="image/jpg, image/jpeg, image/png" class="file-upload__input"
                  type="file" name="preview-file-upload">

              </div>
            </div>
            <section class="modal-pop" *ngIf="showProgress.image" style="position:relative !important;">
              <div class="progress progress-striped active">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                  [attr.aria-valuenow]="progressPercent.image" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="progressPercent.image+'%'">
                  {{progressPercent.image}}%
                </div>
              </div>
            </section>
            <span class="video-file-name align-content-end"
              title="{{vidBlock.placeHolderImage?.name || 'Upload JPEG or PNG'}}">
              {{(vidBlock.placeHolderImage?.name || "Upload JPEG or PNG") }}
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" data-bs-dismiss="modal"
      (click)='closeEditVideoModal()'>Cancel</button>
    <button type="button" class="btn btn__btn-default btn__orange"
      [ngStyle]="(isProgressing.mp4 || isProgressing.image) && {'cursor':'not-allowed'} || {'cursor':'pointer'}"
      [disabled]="isProgressing.mp4 || isProgressing.image" (click)="updateVideoBlock()">Save</button>
  </div>
</div>